import { cloneDeep, get, concat } from 'lodash';
import type from './notification.type';

const initialState = {
  notificationList: [],
  totolCount: 0,
};

const NotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_NOTIFICATION_LIST:
      return {
        ...state,
        notificationList: setArrayByCase(state.notificationList, action?.payload),
        totolCount: parseInt(action?.payload?.data?.totalCount) || 0,
      };
    case type.UPDATE_SOCKET_NOTIFICATION:
      const cloneNotification = cloneDeep(state.notificationList);
      cloneNotification.unshift(action.payload);
      return {
        ...state,
        notificationList: cloneNotification,
        totolCount: cloneNotification?.length,
      };
    default:
      return state;
  }
};
const setArrayByCase = (array, payload) => {
  if (get(payload?.params, 'isScrolled')) {
    array = concat(array, payload?.data?.data);
    return array;
  }
  return payload?.data?.data;
};
export default NotificationReducer;
